<template>
    <base-loader v-if="loading"/>

    <table v-else class="table is-striped is-fullwidth">
        <tbody>
            <tr v-for="member in members" :key="member.id">
                <td>
                    {{member.user.first_name}} {{member.user.last_name}} ({{member.user.email}})
                </td>

                <td>
                    <i v-if="!member.is_owner"
                       @click="remove(member.id)"
                       class="icon fas fa-times-circle"></i>

                    <span v-else class="tag is-light">owner</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: ['members', 'loading'],
    methods: {
        remove(id) {
            this.$store.dispatch('team_members/remove', { id })
                .then(() => this.$emit('removed'));
        },
    },
};
</script>
